import { alpha, useMediaQuery } from '@mui/material';
import { between } from '@ui/style/style';
import { useResponsive } from '@ui/style/useResponsive';
import { headerHeight, spaceAboveHeader, spaceBelowHeader } from '@ui/style/variables';
const useTasksTabStyles = () => {
    const { isMobileIpadNavigation } = useResponsive();
    const TabsHeight = 105.49 + 72.8 + 8;
    const TabsMobileHeight = 42 + 48;
    const spaceAboveTabs = 12;
    const spaceBelowTabs = 16;
    const mobileTaskTabView = 89.18;
    const is1024to1280 = useMediaQuery('(min-width:1024px) and (max-width:1280px)');
    const extraPadding = is1024to1280 || isMobileIpadNavigation ? 20 : 0;
    const cardContainerHeightDesktop = `${spaceAboveHeader + headerHeight + spaceBelowHeader + TabsHeight + spaceBelowTabs + spaceAboveTabs}px`;
    const cardContainerHeightMobile = `${headerHeight + mobileTaskTabView + TabsMobileHeight}px`;
    return {
        // Also update the main container to:
        main: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            height: isMobileIpadNavigation ? '86vh' : '96vh',
        },
        mobileScreenHeader: {
            between,
            flexDirection: 'row',
            backgroundColor: (theme) => theme.palette.common.white,
            borderRadius: (theme) => theme.spacing(3),
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            paddingBottom: 1,
            px: 1
        },
        mobileScreenHeadingButton: {
            display: 'flex',
            justifyContent: 'flex-end',
            paddingX: 2,
            mb: 1,
            alignItems: 'center'
        },
        tasksContainer: {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {
                display: 'none'
            },
            mt: 1,
            maxHeight: isMobileIpadNavigation
                ? `calc(100dvh - ${cardContainerHeightMobile})`
                : `auto`,
            gap: (theme) => theme.spacing(2),
            paddingBottom: 1
        },
        addNewTaskHeading: {
            color: (theme) => theme.palette.text.primary,
            fontWeight: 400,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            bgcolor: (theme) => alpha(theme.palette.background.paper, 0.92),
            borderRadius: (theme) => theme.spacing(1.5),
            px: (theme) => theme.spacing(1.5),
            pb: (theme) => theme.spacing(1.5)
        },
        bottomNewTaskDrawer: {
            p: isMobileIpadNavigation ? 0 : 2,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16
        },
        headingsBar: {
            paddingX: 1,
            paddingTop: 1,
            position: 'sticky',
            top: 16,
            zIndex: 1001,
            backgroundColor: (theme) => theme.palette.background.paper,
        }
    };
};
export default useTasksTabStyles;
